import Menu from 'components/commons/menu'
import { MENU } from 'constants/constant'
import Logo from 'assets/images/logo.png'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Header } from 'components/layout/Header'
import { isLogin } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API } from 'services/api'
import { useDispatch, useSelector } from 'react-redux'
import { setMenu, setProfile, setSidebarList, setUnSavedChangesData } from 'reducers/homeReducer'
import { useClickOutside } from 'hooks/useClickOutside'
import usePreventUnsavedChanges from 'hooks/usePreventUnsavedChanges'
import ModalConfirmation from 'components/commons/modal-confirmation'

export const Layout = ({ children }) => {
    const [widthSidebar, setWidthSidebar] = useState(200)
    const [isResizing, setIsResizing] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { profile, reload, sidebarList, unSavedChangesData: changesData } = useSelector((state) => state.homeReducer)
    const [showLogout, setShowLogout] = useState(false)
    const { fetching: getHome } = useFetch(API.HOME)
    const { fetching: postLogout, isLoading } = useFetch(API.LOGOUT)
    usePreventUnsavedChanges()

    const onNavigate = (url) => {
        if (changesData?.isFilledForm && !changesData?.isClickAnotherPage && `/${url}` !== location?.pathname) {
            dispatch(
                setUnSavedChangesData({
                    isClickAnotherPage: true,
                    urlNavigate: url,
                }),
            )
        } else {
            navigate(url)
        }
    }

    const onConfirm = () => {
        navigate(changesData?.urlNavigate)
        dispatch(
            setUnSavedChangesData({
                isFilledForm: false,
                isClickAnotherPage: false,
                urlNavigate: '',
                isShowConfirm: false,
            }),
        )
    }

    const onHide = () => {
        dispatch(
            setUnSavedChangesData({
                isClickAnotherPage: false,
                isShowConfirm: false,
            }),
        )
    }

    const setShowLogoutToggle = () => {
        setShowLogout(!showLogout)
    }

    const onClickLogout = () => {
        postLogout()
            .then(() => localStorage.clear())
            .catch(() => {})
    }

    const resizeSidebarHandler = (event) => {
        if (isResizing && event?.clientX >= 200 && event?.clientX <= 300) {
            setWidthSidebar(event?.clientX)
        }
    }

    useEffect(() => {
        if (isLogin()) {
            getHome()
                .then((response) => {
                    const { menu, ...responseRest } = response?.data
                    const sidebarList = []
                    MENU?.map((item) => {
                        Object.keys(menu).map((i) => {
                            if (i === item?.key) sidebarList?.push(item)
                        })
                    })
                    dispatch(setProfile({ ...responseRest?.profile }))
                    dispatch(setMenu(menu))
                    dispatch(setSidebarList(sidebarList))
                })
                .catch(() => {})
        }
    }, [reload])

    useClickOutside({
        callback: () => setShowLogout(false),
        elementID: 'logout',
    })

    return isLogin() ? (
        <div className='flex' onMouseMove={resizeSidebarHandler} onMouseUp={() => setIsResizing(false)}>
            <div className={'min-w-0'} style={{ width: widthSidebar }}>
                <Menu
                    className='h-screen sticky top-0 z-20 overflow-y-scroll p-4'
                    items={sidebarList}
                    selectedKey={location.pathname.substring(1)}
                    onClick={onNavigate}
                    contentHeader={
                        <div className={'flex flex-col items-center mb-10'}>
                            <img src={Logo} alt={'logo'} />
                        </div>
                    }
                    contentFooter={<div className={'text-white text-xs pt-5 pb-3'}>AVO 2025 All Right Reserved</div>}
                />
            </div>
            <div onMouseDown={() => setIsResizing(true)} className={'flex w-1 cursor-col-resize'}></div>
            <div className={'flex-1 border-b-2 border-gray-200'}>
                <Header
                    userProfile={profile}
                    breadcrumbPath={location.pathname}
                    onNavigate={onNavigate}
                    showLogout={showLogout}
                    setShowLogoutToggle={setShowLogoutToggle}
                    isLoadingLogout={isLoading}
                    onClickLogout={onClickLogout}
                />
                {children}
            </div>
            <ModalConfirmation
                show={changesData?.isShowConfirm}
                onHide={onHide}
                description={'You have unsaved changes. Do you want to leave?'}
                onConfirm={onConfirm}
                katabuttonConfirmText={'Leave'}
            />
        </div>
    ) : (
        <>{children}</>
    )
}
